export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/shoes.7a4da14.svg";